import React from 'react'
import cx from 'classnames'
import vsbl from 'vsbl'

import Image from '@/image.js'
import store from '../../state/store.js'
import { Plus } from '@/svgs.js'

const switchBackground = (value) => {
  store.hydrate({
    background: value
  })()
}

class LocationLevel extends React.Component {
  constructor () {
    super()
    this.state = {
      open: false,
      active: 1
    }
    this.vs = null
    this.slideshow = React.createRef()
  }
  componentDidMount () {
    const Flickity = require('flickity')
    const slideshow = this.slideshow.current
    const flky = new Flickity(slideshow, {
      contain: true,
      wrapAround: true,
      pageDots: false,
      watchCSS: true,
      bgLazyLoad: 2,
      cellAlign: 'center',
      prevNextButtons: false
    })

    this.setState({
      flky: flky
    })

    if (this.props.level === 0) {
      this.vs = vsbl(this.slideshow.current)(() => {
        switchBackground('purple')
      }, () => {
        switchBackground('four')
      })

      this.vs.update()
    }

    if (this.props.level === 1) {
      this.vs = vsbl(this.slideshow.current)(() => {
        switchBackground('blue')
      })

      this.vs.update()
    }

    flky.on('select', index => this.setState({ active: index }))

    if (this.props.level === 2) {
      this.vs = vsbl(this.slideshow.current)(() => {
        switchBackground('orange')
      }, () => {
        switchBackground('four')
      })

      this.vs.update()
    }

    setTimeout(() => {
      flky.resize()
    }, 400)
  }
  render () {
    const {
      description,
      title,
      iconId,
      collapsedCTA,
      collapsedInformation,
      levelImages
    } = this.props
    return (
      <div className='f fw jcb ais location__level mb15'>
        <div className='location__level-text'>
          <div className='location__level-title f jcs aic'>
            <div className='location__level-icon mr15 bcw f jcc aic'>
              {iconId && (<Image className='x block p1' imageId={iconId} />)}
            </div>
            <h2 className='h1 mb0 p0 mt0'>{title}</h2>
          </div>
          <p>{description}</p>
          {collapsedCTA && (
            <div>
              <div onClick={() => this.setState({ open: !this.state.open })} className={cx('py1 mt15 f fw jcb aic location__level-collapse', {
                'is-open': this.state.open
              })}>
                <span className='caps block medium s16'>{collapsedCTA}</span>
                <span className='location__level-plus f jcc aic bct'>
                  <Plus />
                </span>

                <div className='location__level-hidden x'>
                  <p className='s18'>{collapsedInformation}</p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='rel x location--slides'>
          <div className='x location__slideshow' ref={this.slideshow}>
            {levelImages && levelImages.map(level => (
              <Image className='x mb15' imageId={level.imageId} key={level._key} />
            ))}
          </div>

          <div className='abs bottom left p1 f jcs aic location--slides_num'>
            {levelImages && levelImages.map((im, i) => (
              <div
                key={i}
                className={cx('brand__slideshow-nums mr1 f jcc aic cw', {
                  'active': this.state.active === i
                })}
                onClick={() => this.state.flky.select(i)}><span>{i + 1}</span></div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default LocationLevel
